import calendarDateFragmentRawString from '../CalendarDateFragment.graphql'

export const calendarDateFragmentString = calendarDateFragmentRawString

export type CalendarDateFragment = {
  __typename: 'CalendarDate'
  day: number
  month: number
  year: number
}

export const isCalendarDateFragment = (
  fragment: any,
): fragment is CalendarDateFragment =>
  fragment &&
  fragment.__typename === 'CalendarDate' &&
  typeof fragment.day === 'number' &&
  typeof fragment.month === 'number' &&
  typeof fragment.year === 'number'
